/**
 * Dashboard Service
 * Handles all dashboard-related API calls
 */

import { apiGet } from './apiClient';
import API_CONFIG from './apiConfig';

/**
 * Get user dashboard data
 * @returns {Promise}
 */
export const getDashboard = async () => {
  return apiGet(API_CONFIG.endpoints.dashboard);
};

